var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaylistSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.055 1.992h14c0.552 0 1-0.448 1-1s-0.448-1-1-1h-14c-0.552 0-1 0.448-1 1s0.448 1 1 1zM1.055 7.992h14c0.552 0 1-0.448 1-1s-0.448-1-1-1h-14c-0.552 0-1 0.448-1 1s0.448 1 1 1zM16.055 12.992c0-0.552-0.448-1-1-1h-14c-0.552 0-1 0.448-1 1s0.448 1 1 1h14c0.552 0 1-0.448 1-1zM31.652 10.142l-9.778-9.778c-0.309-0.31-0.77-0.37-1.143-0.188-0.392 0.136-0.675 0.503-0.675 0.942v22.137c-1.060-0.785-2.451-1.266-3.98-1.266-3.314 0-6.003 2.243-6.003 5.009s2.688 5.011 6.003 5.011c3.317 0 6.003-2.244 6.003-5.011 0-0.125-0.012-0.248-0.023-0.371v-23.253l8.183 8.183c0.39 0.39 1.024 0.39 1.415 0s0.39-1.024 0-1.415zM20.055 27.094c-0.072 1.39-1.693 2.9-4.004 2.9-2.364 0-4.011-1.58-4.011-2.996 0-1.417 1.647-2.995 4.011-2.995 2.311 0 3.932 1.508 4.004 2.899v0.191z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistSvgrepoCom);
export default __webpack_public_path__ + "static/media/playlist-svgrepo-com.6a669bd938ac71275df387b0fb97f60b.svg";
export { ForwardRef as ReactComponent };